<nb-layout>
  <nb-layout-column>
    <nb-card [nbSpinner]="submitted || isLoadingOnderhoudsmodus" nbSpinnerStatus="info" nbSpinnerSize="xlarge"
      [nbSpinnerMessage]="'ALGEMEEN.EVEN_GEDULD' | translate">
      <nb-card-body>
        <div class="row" *ngIf="onderhoudsmodusActief && !isLoadingOnderhoudsmodus">
          <div class="col-md-12">
            <p style="text-align: center;" [innerHtml]="onderhoudsmodusTekst | safeHtml"></p>
          </div>
        </div>

        <div class="col-xl-4 col-lg-6 col-md-8 col-sm-12" *ngIf="!onderhoudsmodusActief && !isLoadingOnderhoudsmodus">
          <h3 class="title">{{ 'LOGIN.TITEL' | translate:{environmentName} }}</h3>
          <!-- todo even environment meepakken -->
          <div *ngIf="!requiresMfa">
            <p class="form-text sub-title">{{ 'LOGIN.LOGIN_HINT' | translate }}</p>
            <form (ngSubmit)="login()" #form="ngForm" autocomplete="nope">
              <div *ngIf="errors && errors.length > 0 && !submitted" class="alert alert-danger" role="alert">
                <div><strong>{{ 'LOGIN.FOUTMELDING' | translate }}</strong></div>
                <div *ngFor="let error of errors">{{ error }}</div>
              </div>
              <div class="form-group"> <label for="input-username" class="sr-only">{{ 'LOGIN.GEBRUIKERSNAAM' | translate
                  }}</label> <input name="username" [(ngModel)]="user.username" id="input-username" class="form-control"
                  [placeholder]="'LOGIN.GEBRUIKERSNAAM' | translate | lowercase" #username="ngModel"
                  [class.form-control-danger]="username.invalid && username.touched" autofocus [required]="true">
                <small class="form-text error"
                  *ngIf="username.invalid && username.touched && username.errors?.required">{{
                  'LOGIN.MELDING.GEBRUIKERSNAAM_VERPLICHT' | translate }}</small>
              </div>
              <div class="form-group"> <label for="input-password" class="sr-only">{{ 'LOGIN.WACHTWOORD' | translate
                  }}</label> <input name="password" [(ngModel)]="user.password" type="password" id="input-password"
                  class="form-control" [placeholder]="'LOGIN.WACHTWOORD' | translate | lowercase" #password="ngModel"
                  [class.form-control-danger]="password.invalid && password.touched" [required]="true">
                <small class="form-text error"
                  *ngIf="password.invalid && password.touched && password.errors?.required">{{
                  'LOGIN.MELDING.WACHTWOORD_VERPLICHT' | translate }}</small>
              </div>
              <div class="pull-right"><a [routerLink]="['/auth/forget']"><span>{{ 'LOGIN.WACHTWOORD_VERGETEN' |
                    translate
                    }}</span></a></div>
              <br />
              <button [disabled]="submitted || !form.valid" class="btn btn-block btn-success"
                [class.btn-pulse]="submitted">{{ 'LOGIN.BUTTON.INLOGGEN' | translate }}</button>
            </form>
          </div>
          <div *ngIf="requiresMfa">
            <div class="mfa-info">
              <div *ngIf="errors && errors.length > 0" class="alert alert-danger" role="alert">
                <div><strong>{{'LOGIN.MFA.FOUTMELDING' | translate}} </strong></div>
                <div *ngFor="let error of errors">{{ error }}</div>
              </div>
              <p *ngIf="errors.length == 0 && !isUsingRecoveryCode">{{'LOGIN.MFA.CODE_INVOEREN' | translate}}</p>
              <p *ngIf="errors.length == 0 && isUsingRecoveryCode">{{'LOGIN.MFA.HERSTELCODE_INVOEREN' | translate}}</p>
            </div>

            <!-- Normale MFA Code Invoer -->
            <div *ngIf="!isUsingRecoveryCode" class="mfa-container" [class.disabled]="isVerifying">
              <div class="mfa-inputs">
                <input *ngFor="let box of boxes; let i = index" maxlength="1" type="text" class="mfa-input"
                  pattern="[0-9]*" inputmode="numeric" #codeBox (input)="onInput($event, i)"
                  (keydown)="onKeyDown($event, i)" (paste)="onPaste($event)" [id]="'mfa-' + i"
                  autocomplete="one-time-code">
              </div>
              <div class="loader-overlay" *ngIf="isVerifying">
                <div class="verify-content">
                  <div class="mfa-spinner"></div>
                  <p>{{'LOGIN.MFA.VALIDEREN' | translate}}</p>
                </div>
              </div>
            </div>

            <!-- Herstelcode Invoer -->
            <div *ngIf="isUsingRecoveryCode" class="mfa-container" [class.disabled]="isVerifying">
              <div class="recovery-inputs">
                <!-- Eerste 5 karakters -->
                <div class="recovery-group">
                  <input *ngFor="let box of [0, 1, 2, 3, 4]; let i = index" maxlength="1" type="text" class="mfa-input"
                    (input)="onRecoveryInput($event, i)" (keydown)="onRecoveryKeyDown($event, i)"
                    (paste)="onRecoveryPaste($event)" [id]="'recovery-' + i" autocomplete="off">
                </div>
                <span class="recovery-separator">-</span>
                <!-- Tweede 5 karakters -->
                <div class="recovery-group">
                  <input *ngFor="let box of [5, 6, 7, 8, 9]; let i = index" maxlength="1" type="text" class="mfa-input"
                    (input)="onRecoveryInput($event, i + 5)" (keydown)="onRecoveryKeyDown($event, i + 5)"
                    (paste)="onRecoveryPaste($event)" [id]="'recovery-' + (i + 5)" autocomplete="off">
                </div>
              </div>
              <div class="loader-overlay" *ngIf="isVerifying">
                <div class="verify-content">
                  <div class="mfa-spinner"></div>
                  <p>{{'LOGIN.MFA.VALIDEREN' | translate}}</p>
                </div>
              </div>
            </div>

            <div style="text-align: center; margin-top: 16px;">
              <a href="" *ngIf="!isUsingRecoveryCode" (click)="restoreMfa($event)" style="cursor: pointer;">
                {{ 'LOGIN.MFA.GEEN_TOEGANG' | translate }}
              </a>
              <a href="" *ngIf="isUsingRecoveryCode" (click)="backToMfa($event)" style="cursor: pointer;">
                {{ 'LOGIN.MFA.TERUG_NAAR_CODE' | translate }}
              </a>
            </div>
          </div>
        </div>
      </nb-card-body>
    </nb-card>
  </nb-layout-column>
</nb-layout>